import { AdapterRegistry } from '../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { IModel } from 'app/model/base/annotation';
import { SalesforceLinkedServiceAdapter } from 'app/model/adapters/linkedservices/salesforce-linkedservice.adapter';
import { SalesforceServiceCloudLinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SalesforceServiceCloudLinkedService),
    disabled: __IS_FABRIC_DPE__,
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                environmentUrl: '*',
                username: '*',
                password: 'secret',
                securityToken: 'secret',
                apiVersion: '*',
                encryptedCredential: '*'
            },
            parameters: '*'
        }
    }
})
export class SalesforceServiceCloudLinkedServiceAdapter extends SalesforceLinkedServiceAdapter {
    protected modelConstructor(): new () => SalesforceServiceCloudLinkedService {
        return SalesforceServiceCloudLinkedService;
    }

    protected model(): IModel {
        return SalesforceServiceCloudLinkedService.MODEL;
    }
}
